import SEO from "../../../../src/components/seo";
import * as React from 'react';
export default {
  SEO,
  React
};